(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lecce-afterpay-message"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateShopPayFallback = () => {
      document.querySelectorAll('.lecce-shop-pay-message').forEach((container) => {
        const fallback = container.querySelector('[data-lecce-shop-pay-fallback]');
        const nativeTerms = container.querySelector('shopify-payment-terms');
        if (!fallback) return;

        const nativeVisible = nativeTerms && nativeTerms.getBoundingClientRect().height > 0;
        fallback.classList.toggle('is-visible', !nativeVisible);
      });
    };

    requestAnimationFrame(updateShopPayFallback);
    window.setTimeout(updateShopPayFallback, 800);
    document.addEventListener('shopify:section:load', updateShopPayFallback);
  })();
  } catch(e) { console.error(e); }
})();

})();
